export default "__VITE_ASSET__Drp3S3j5__"